module.exports = __webpack_public_path__ + "img/preview-1.3153f1b4.png";